import { paginationOptions, navigationOptions } from "Config/slider/default"
import { productB2bOnSaleSliderOptions, productB2cOnSaleSliderOptions, productsSliderOptions, promotionProductsSliderOptions, modalAlternativesSliderOptions, pairedProductsSliderOptions } from "Config/slider/product"
import { productImageOptions } from "Config/slider/product-image"
import { indexB2cBannerSliderOptions, indexB2bBannerSliderOptions,b2bLeafletSliderOptions, listingB2bBannerSliderOptions, listingB2cBannerSliderOptions } from "Config/slider/banner"
import {articleProductsSliderOptions} from 'Config/slider/article';
import { alternativeRecipesSlider, recipesSlider } from "Config/slider/recipes"
import { recipesSliderOptions } from "Config/slider/recipe"
import { squaresSlider } from "Config/slider/squares"
import { blogBoxSlider } from "Config/slider/blog-box"
import { heurekaSliderOptions } from "Config/slider/heureka"

import { rSwiperVisibleItems } from 'Functions/swiper-visible-items'
import { rSwiperCssNavFix } from 'Functions/swiper-css-nav-fix'
import { Pagination, Navigation } from 'swiper';
import { dashboardProductsSlider } from "./dashboard-products"
import { categoriesSliderOptions } from "Config/slider/category";

export const sliderOptions = instance => {
    // default options
    let options = {
        simulateTouch: false,
        watchOverflow: true,
        preventInteractionOnTransition: true,
        roundLengths: true,
        modules: [Pagination, Navigation, rSwiperVisibleItems, rSwiperCssNavFix]
    }

    if (instance.paginationEl) {
        options = {...options, ...paginationOptions(instance)}
    }

    if (instance.prevEl && instance.nextEl) {
        options = {...options, ...navigationOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-products')) {
        options = {...options, ...productsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-promotion-products-slider')) {
        options = {...options, ...promotionProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-categories')) {
        options = {...options, ...categoriesSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-recipes')) {
        options = {...options, ...recipesSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-b2b-leaflet')) {
        options = {...options, ...b2bLeafletSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-b2b-product-on-sale')) {
        options = {...options, ...productB2bOnSaleSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-b2c-product-on-sale')) {
        options = {...options, ...productB2cOnSaleSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-product-image-slider')) {
        options = {...options, ...productImageOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-b2b-index-banner')) {
        options = {...options, ...indexB2bBannerSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-b2c-index-banner')) {
        options = {...options, ...indexB2cBannerSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-recipes-slider')) {
        options = {...options, ...recipesSlider(instance, options)}
    }

    if (instance.hasAttribute('r-squares-slider')) {
        options = {...options, ...squaresSlider(instance, options)}
    }

    if (instance.hasAttribute('r-blog-box-slider')) {
        options = {...options, ...blogBoxSlider(instance, options)}
    }

    if (instance.hasAttribute('r-dashboard-products-slider')) {
        options = {...options, ...dashboardProductsSlider(instance, options)}
    }

    if (instance.hasAttribute('r-slider-alternative-recipes')) {
        options = {...options, ...alternativeRecipesSlider(instance, options)}
    }

    if (instance.hasAttribute('r-slider-b2b-listing-banner')) {
        options = {...options, ...listingB2bBannerSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-b2c-listing-banner')) {
        options = {...options, ...listingB2cBannerSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-article-products-slider')) {
        options = {...options, ...articleProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-modal-alternatives')) {
        options = {...options, ...modalAlternativesSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-paired-products')) {
        options = {...options, ...pairedProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-recombee-homepage') || instance.hasAttribute('r-slider-recombee-listing') || instance.hasAttribute('r-slider-recombee-product')) {
        options = {...options, ...productsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-heureka')) {
        const maxVisibleItems = instance.getAttribute('r-max-visible-items') || 10;
        options = {...options, ...heurekaSliderOptions(instance, options, maxVisibleItems)}
    }

    return {...options, ...instance.customOptions}
}